export const apiurl = "https://api.codtsy.org";
export const donateurl = "https://eazypay.icicibank.com/eazypayLink?P1=zEa+Zb2ZRdrPrS8aB3sjTg=="
export const volunteerurl = "https://forms.gle/T1vCN68x8jkg9YEh8"
